import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchAreasSearch } from "src/Pages/Company/OrganizationStructure/api";

const useFetchAreasSearch = ({
  companyId,
  structureId,
  enabled,
  filterString,
}: {
  companyId: string;
  structureId: string | undefined;
  enabled: boolean;
  filterString?: string;
}) => {
  let filters: string | null = null;

  if (filterString && filterString !== "") {
    const sanitizedFilterString = filterString.replace(/[^\p{L}0-9 ]/gu, "");
    filters = `(areaName=like=*${sanitizedFilterString}*)`;
  }

  return useInfiniteQuery({
    enabled,
    queryKey: ["fetchAreasSearch", companyId, structureId, filterString],
    queryFn: ({ pageParam }: { pageParam: string | null }) =>
      fetchAreasSearch({ pageParam, filters, companyId, structureId }),
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });
};

export default useFetchAreasSearch;
